const KEY_CODE_SPACE = 32;
const KEY_CODE_ENTER = 13;
export const selectionKeyCodes = new Set([KEY_CODE_SPACE, KEY_CODE_ENTER]);
